<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="this.$route.meta.breadcrumb"></b-breadcrumb>                      
        <b-card 
            class="p-1 mb-3 bg-white rounded"
            footer-bg-variant="transparent">
            <alert
                :variant="alert.variant"            
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>
            <b-row>
                <b-col>
                    <b-form-group label="Verificar autenticidade"   label-class="font-weight-bold">
                        <b-input-group >  
                            <b-form-input 
                                id="verifica-autenticidade" 
                                v-model="codigoAutenticidade" 
                                placeholder="Digite aqui o código da assinatura, localizado na lateral do documento."
                                @keydown.native="keydownVerificarAutenticidade">
                            </b-form-input>
                            
                            <b-input-group-append>
                                <b-button variant="primary" class="fa fa-search" @click="reloadPage(codigoAutenticidade)"></b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>             
                </b-col>   
            </b-row>
            <p class="msg-verificacao-disponivel">*A verificação de autenticidade só está disponível para documentos publicados a partir de {{$constantes.sistema.DATA_INICIO_CADASTROS}}. </p>                                                                                                 
            <div v-if="documento_valido != ''" class="sit-doc d-flex">
                <span class="dados-doc mr-2"><strong>Situação do documento: </strong></span>
                <b-badge variant="success" v-if="documento_valido && mensagem">{{mensagem}} <i class="fa fa-check"></i></b-badge>
                <b-badge variant="danger" v-else-if="!documento_valido && mensagem">Documento inválido <i class="fa fa-times"></i></b-badge>
                <span v-else>...</span>
            </div>
            <hr />
            <div>
                <p class="msg-erro" v-if="mensagem && !documento_valido">{{mensagem}}</p>

                <div class="dados-doc" v-if="assinatura">
                    <p><strong>Código da assinatura:</strong> {{$route.params.codigo}}</p> 
                    <p><strong>Data da assinatura:</strong> {{assinatura.data}}</p>                                                          
                </div>
            </div>
            <b-link class="dados-doc" v-if="nome_minio"  
                @click="$helper.exibirDocumento($env.VUE_APP_URL_API, nome_minio, prefix)">                                   
                <i class="fa fa-file-pdf-o mr-1 mt-2"></i> Acesse o documento
            </b-link>
            <template v-slot:footer >                                  
                <b-row >  
                    <b-col class="text-left">   
                        <b-button
                            size="sm" 
                            variant="outline-secondary"                                 
                            @click.prevent="$router.go(-1)"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>          
                    </b-col>                           
                </b-row>
            </template>        
        </b-card>
    </div>
</template>

<script>

import Alert from '../../models/Alert'
import DataAtual from '../../components/DataAtual';

export default {
    name: 'verificarautenticidade',
    
    components: {
        DataAtual
    },
    
    data(){
        return {
            documento_valido: '',
            mensagem: '',
            assinatura: '',
            nome_minio: '',
            prefix: null,
            codigoAutenticidade: '',
            alert: new Alert(),
        }
    },
    methods: {
        
        alertDismissed(){           
            this.alert = new Alert();
        },

        verificar(codigo) {
            this.$api.assinaturadigital.autenticidade(codigo).then((res)=> {
                const result = res.data.data;
                this.documento_valido = result.documento_valido;
                this.mensagem = result.mensagem;

                if( result.documento ) {
                    this.nome_minio = result.documento.nome_minio;
                    this.prefix = result.documento.prefix;
                }

                if( result.documento_valido ) {
                    this.assinatura = result.assinatura;
                } 
            })                
            .catch(error => {
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       error.response.data.errors);
            });
        },

        keydownVerificarAutenticidade(event){
            if (event.which === 13) {// 13 = Tecla Enter
                this.reloadPage();
            }        
        },

        reloadPage() {
            if( this.codigoAutenticidade.length <= 0 ) return;            
            window.location.href = window.location.origin +'/'+ this.$route.name + '/'+ this.codigoAutenticidade;
        }

    },
    mounted(){
        if( this.$route.params.codigo) {
            this.codigoAutenticidade = this.$route.params.codigo;
            this.verificar(this.codigoAutenticidade);
        }
    },

}
</script>

<style scoped>
    .data {
        font-size: 90%;
        text-align: right;
        padding-bottom: 0.25rem;
    }
    .sit-doc {
        align-items: center;
    }
    .breadcrumb{
        font-size: 0.9em;
    }
    
    .msg-erro{
        color: grey;           
        font-size: 0.88em;
        text-align: center;
        justify-content: center;
        margin-top: 1em;    
    }
    
    .dados-doc{
        font-size: 0.9em;
    }


    .msg-verificacao-disponivel{       
       color: red;  
       font-size: 0.8em;   
       font-weight: lighter;    
       text-align: left;   
    }


</style>